import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "version" }

import { ref } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'WhatsNew',
  setup(__props) {

const { t } = useI18n();
const expanded = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_van_row, { class: "section-head" }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, { span: "22" }, {
          default: _withCtx(() => [
            _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)('donwload.whatsNew')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, { span: "2" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_icon, {
              name: "arrow",
              size: "16",
              color: "#9ca3af"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('appStore.whatsNewVersion')) + " · " + _toDisplayString(_unref(t)('appStore.whatsNewUpdatedAt')), 1),
    _createElementVNode("p", {
      class: _normalizeClass(["body", { clamped: !expanded.value }])
    }, [
      _createTextVNode(_toDisplayString(_unref(t)('appStore.whatsNewBody')) + " ", 1),
      _createElementVNode("span", {
        class: "toggle",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (expanded.value = !expanded.value))
      }, _toDisplayString(expanded.value ? _unref(t)('common.less') : _unref(t)('common.more')), 1)
    ], 2)
  ]))
}
}

})